import { Button } from 'reactstrap';
import { FeatureCollection } from 'geojson';
import * as FileSaver from 'file-saver';
import { featureCollection } from '@turf/turf';
import { unaugmented } from '../../../utils/layerAugmenters';
import { exportFileName } from '../../../utils/utils';

// Non-exhaustive set of layer properties
interface Layer {
  augment: ({ data }: { data?: FeatureCollection }) => FeatureCollection;
  data?: FeatureCollection;
  id: string;
}

export interface ExportLayerJsonButtonProps {
  layer: Layer;
  title: string;
}

// Give every feature a name in the export and remove feature ids
const editFeatureProperties = (
  featureColl?: FeatureCollection,
): FeatureCollection =>
  featureCollection(
    (featureColl?.features || []).map((feature, i) => {
      return {
        ...feature,
        id: undefined, // Do not export id
        properties: {
          ...feature.properties,
          id: undefined, // Do not export id
          name: feature.properties?.name || `Feature ${i + 1}`,
        },
      };
    }),
  );

const ExportLayerJsonButton = ({
  layer,
  title,
  ...buttonProps
}: ExportLayerJsonButtonProps) => {
  const { augment = unaugmented } = layer;
  const onClick = async () => {
    // Augment non-custom layer features
    const augmentedData = augment(layer);
    const editedData = editFeatureProperties(augmentedData);
    const content = JSON.stringify(editedData);
    const blob = new Blob([content], { type: 'application/json' });
    FileSaver.saveAs(blob, exportFileName(title, 'json'));
  };

  return <Button onClick={onClick} {...buttonProps} />;
};

export default ExportLayerJsonButton;
